import { gql } from "apollo-boost";


export const GET_CATEGORYS = gql`

query Categories($where: CategoryWhereInput, $orderBy: OrderByInput, $skip: Int, $limit: Int) {
    categories(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit) {
      total
      data {
        id
        name
        detail
        isDeleted
        shop {
          name
        }
        createdBy {
          username
        }
        updatedBy {
          username
        }
        createdAt
        updatedAt
        companyOption 
        phoneOption 
        emailOption 
        addressOption 
        websiteOption
      }
    }
  }
`